/* eslint-disable */
import authForgotPassword from './Actions/AuthForgotPassword.action';
import authHelpLink from './Actions/AuthHelpLink.action';
import authLoginWithUsernameAndPassword from './Actions/AuthLogin.action';
import authLoginSuccess from './Actions/AuthLoginSuccess.action';
import authLogout from './Actions/AuthLogout.action';
import authOnAuthPresenceChanged from './Actions/AuthOnPresenceChanged.action';
import authOnAuthStateChanged from './Actions/AuthOnStateChanged.action';
import authTnc from './Actions/AuthTnc.action';
import authUnlock from './Actions/AuthUnlock.action';

const authActionCreators = {
  authForgotPassword,
  authHelpLink,
  authLoginSuccess,
  authLoginWithUsernameAndPassword,
  authLogout,
  authOnAuthPresenceChanged,
  authOnAuthStateChanged,
  authTnc,
  authUnlock,
};

export default authActionCreators;
